import React, { useEffect, useState, useRef } from "react";
import useGetApi from "../../services/useGetApi";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Col, Collapse, Row, Tabs } from "antd";
import ReactPlayer from "react-player";
import usePut from "../../services/usePut";
import {
  BookFilled,
  BulbFilled,
  FilePdfOutlined,
  QuestionCircleFilled,
  ReadOutlined,
} from "@ant-design/icons";
import LiveClass from "../../components/ReadCourse/LiveClass";
import ConductQuiz from "../../components/ReadCourse/ConductQuiz";
import { parse } from "tinyduration";

const InstructorQuizResult = () => {
  const { id, studentId, sectionId, quizId } = useParams();
  const { Panel } = Collapse;
  const navigate = useNavigate()

  const [activeSectionId, setActiveSectionId] = useState(null);
  const [activeContent, setActiveContent] = useState(null);
  const [currentLessonId, setLessonId] = useState(null);
  const [isLoading, courseError, courseInfo, getCourseInfo] = useGetApi(
    `course/details/${id}`,
    [],
    true
  );
  const [quizResultsLoading, quizResultsError, quizResults, getQuizResults] =
    useGetApi(`quizResults/${studentId}/${id}`, [], true);

  useEffect(() => {
    if (sectionId) {
      setActiveSectionId(sectionId);
    }
  }, [sectionId]);

  useEffect(() => {
    if (id !== null || id !== undefined) {
      getCourseInfo(`course/details/${id}`);
      getProgressResults(`progress/student/course/${id}`);
      if (studentId !== null) {
        getQuizResults(`quizResults/${studentId}/${id}`);
      }
    }
  }, [id]);

  const handleLessonClick = (sectionId, lesson) => {
    setActiveSectionId(sectionId);
    // console.log('lssonsssssss',lesson)
    setActiveContent({ type: "lesson", content: lesson });
    setLessonId(lesson?.id);
  };

  const handleQuizClick = (sectionId, quiz) => {
    setActiveSectionId(sectionId);
    setActiveContent({ type: "quiz", content: quiz });
  };

  const parseDuration = (duration) => {
    if (!duration) return 0;

    const parsedDuration = parse(duration);
    return (
      (parsedDuration.seconds ?? 0) +
      (parsedDuration.minutes ?? 0) * 60 +
      (parsedDuration.hours ?? 0) * 3600 +
      (parsedDuration.days ?? 0) * 86400 +
      (parsedDuration.weeks ?? 0) * 604800 +
      (parsedDuration.months ?? 0) * 2592000 + // Approximate (30 days)
      (parsedDuration.years ?? 0) * 31536000 // Approximate (365 days)
    );
  };


  useEffect(() => {
    if (!courseInfo || !courseInfo.sections?.length) {
      return;
    }
  
    const numericSectionId = Number(sectionId);
    const numericQuizId = Number(quizId);
  
    if (isNaN(numericSectionId) || isNaN(numericQuizId)) {
      return;
    }
  
    if (numericSectionId && numericQuizId) {
     
      const targetSection = courseInfo.sections.find(
        (section) => section.id === numericSectionId
      );
  
      if (!targetSection) {
        return;
      }
  
      // Check if quizzes exist in the section
      if (targetSection.quizzes?.length) {
        const targetQuiz = targetSection.quizzes.find(
          (quiz) => quiz.id === numericQuizId
        );
  
        if (targetQuiz) {
          handleQuizClick(numericSectionId, targetQuiz); 
          setActiveSectionId(numericSectionId);
          return;
        } else {
          console.log('Could not find quiz with provided quizId:', numericQuizId);
        }
      } else {
        console.log('No quizzes available in the target section');
      }
    }
  
    // Default behavior - first available content
    const firstSection = courseInfo.sections[0];
    if (firstSection.lessons?.length) {
      // console.log('Defaulting to first lesson:', firstSection.lessons[0]);
      handleLessonClick(firstSection.id, firstSection.lessons[0]);
    } else if (firstSection.quizzes?.length) {
      // console.log('Defaulting to first quiz:', firstSection.quizzes[0]);
      handleQuizClick(firstSection.id, firstSection.quizzes[0]);
    }
  
  }, [courseInfo, sectionId, quizId]);
  
  

  // const getEmbedUrl = (videoUrl) => {
  //   var url = videoUrl;
  //   var id = url.split("?v=")[1] ?? "";
  //   var embedLink = "http://www.youtube.com/embed/" + id;
  //   return embedLink;
  // };

  const [studentProgress, setStudentProgress] = useState({});

  const [completedLessons, setCompletedLesons] = useState();
  const [completedPercentage, setCompletedPercentage] = useState();
  const [numberOfLessons, setNumberOfLessons] = useState(0);
  const playerRef = useRef(null);
  const [watchTime, setWatchTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const [currentLessonDuration, setCurrentLessonDuration] = useState(null);

  const [progressLoading, progressError, progressResults, getProgressResults] =
    useGetApi(`progress/student/course/${id}`, [], true);

  const [putLoading, errorMsg, putData] = usePut();

  const convertTimeToSeconds = (time) => {
    if (!time) return 0; // If time is invalid or null, return 0
    const [hours, minutes, seconds] = time.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  };

  useEffect(() => {
    // Check if studentProgress and currentLessonId are available
    if (studentProgress && currentLessonId) {
      const watchedDuration =
        studentProgress?.watchedDuration?.[currentLessonId];

      // If the watched duration exists, convert it to seconds
      if (watchedDuration) {
        const seconds = convertTimeToSeconds(watchedDuration);
        // console.log(seconds, "sssssssssssssss");
        setCurrentLessonDuration(seconds);
        // You can update your state with the value, for example:
        // setCurrentLessonDuration(seconds);
      } else {
        console.log("No watched duration for this lesson");
      }
    } else {
      console.log("No studentProgress or currentLessonId available");
    }
  }, [studentProgress, currentLessonId]);

  useEffect(() => {
    if (progressResults) {
      const watchedDuration = progressResults?.watchedDuration;
      // console.log(watchedDuration, 'watch');

      let parsedWatchedDuration = {};

      if (watchedDuration && typeof watchedDuration === "string") {
        try {
          if (
            watchedDuration.trim().startsWith("{") &&
            watchedDuration.trim().endsWith("}")
          ) {
            const fixedString = watchedDuration
              .replace(/'/g, '"') // Replace single quotes with double quotes
              .replace(/([{,])(\d+):/g, '$1"$2":'); // Fix keys without quotes

            parsedWatchedDuration = JSON.parse(fixedString);
          } else {
            // If it's not a JSON string (e.g., "214:56"), set empty object
            parsedWatchedDuration = {};
          }
        } catch (error) {
          console.error("Failed to parse watchedDuration:", error);
          parsedWatchedDuration = {}; // Fallback to empty object on error
        }
      }

      // console.log(parsedWatchedDuration, 'parsed'); // Debug log

      setStudentProgress((prev) => ({
        ...progressResults,
        watchedDuration: parsedWatchedDuration, // Always an object (never undefined/null)
      }));
    }
  }, [progressResults]);

  // useEffect(() => {
  //   console.log('Updated studentProgress:', studentProgress);
  // }, [studentProgress]);

  const convertDurationToString = (obj) => {
    const watchedDurationString = `{${Object.entries(obj)
      .map(([key, value]) => `${key}:'${value}'`)
      .join(",")}}`;

    return watchedDurationString;
  };

  const studentProgressRef = useRef(studentProgress);

  useEffect(() => {
    if (studentProgress && courseInfo?.sections) {
      let count = 0;
      let totalLessonsCount = 0;

      courseInfo.sections.forEach((section) => {
        section?.lessons?.forEach((lesson) => {
          totalLessonsCount++;

          const lessonDuration = convertTimeToSeconds(lesson?.duration);
          const lessonId = lesson?.id;

          if (lessonId && lessonDuration && studentProgress) {
            const watchedTime = convertTimeToSeconds(
              studentProgress?.watchedDuration?.[lessonId]
            );

            if (watchedTime && watchedTime > lessonDuration - 10) {
              count++;
            }
          }
        });
      });

      // Only update the state if the values have changed
      if (
        count !== studentProgressRef.current.completedLessons ||
        totalLessonsCount !== studentProgressRef.current.totalLessons
      ) {
        setCompletedLesons(count);
        setNumberOfLessons(totalLessonsCount);
        setStudentProgress((prev) => ({
          ...prev,
          completedLessons: count,
          totalLessons: totalLessonsCount,
        }));

        // Update the ref to prevent unnecessary updates
        studentProgressRef.current = {
          ...studentProgress,
          completedLessons: count,
          totalLessons: totalLessonsCount,
        };
      }
    }
  }, [courseInfo, studentProgress]);

  // const calculateCompletedPercentage = () =>{
  //    let percentage = Math.floor( (completedLessons/numberOfLessons)*100)
  //    setCompletedPercentage(percentage)
  //    setStudentProgress((prev)=>({
  //     ...prev,
  //     completionPercentage : percentage
  //   }))
  // }

  // useEffect(() =>{
  //   calculateCompletedPercentage()
  // },[numberOfLessons,completedLessons])

  // Track watch time when playing
  useEffect(() => {
    if (isPlaying) {
      const id = setInterval(() => {
        if (playerRef.current) {
          const currentTime = playerRef.current.getCurrentTime();
          // setWatchTime(currentTime);
          // console.log(`Watched: ${currentTime.toFixed(1)} seconds`);
        }
      }, 5000); // Update every 5 seconds
      setIntervalId(id);
    } else if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(null);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isPlaying]);

  const convertTimTeoHHMMSS = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    const formattedTime = `${String(hours).padStart(2, "0")}:${String(
      minutes
    ).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
    return formattedTime;
  };

  const handlePlay = () => {
    setIsPlaying(true);
    console.log("Video started playing");
  };

  const handlePause = () => {
    setIsPlaying(false);
    console.log("Video paused");
  };

  const handleVideoEnded = () => {
    console.log("Video completed!");
    // updateData()
    setIsPlaying(false);
  };

  const handleProgress = (state) => {
    // This fires during playback
    if (studentProgress?.watchedDuration && isPlaying) {
      console.log("Progress:", state.playedSeconds);
      const secondsTime = convertTimTeoHHMMSS(state.playedSeconds);
      setWatchTime(secondsTime);
      setStudentProgress((prev) => ({
        ...prev,
        watchedDuration: {
          ...prev.watchedDuration,
          [currentLessonId]: secondsTime,
        },
      }));
    }
  };

  const handleDuration = (duration) => {
    setDuration(duration);
    console.log("Video duration:", duration);
  };

  // Update the ref whenever `studentProgress` is updated
  useEffect(() => {
    studentProgressRef.current = studentProgress;
  }, [studentProgress]);

  //update the student progress




  return (
    <Row >
        <Row className='quiz_header'>
            <Col>LMS</Col>
            <Col className='middle'>
            <h4>Quiz Results</h4>
            </Col>
            <Col>
             <button 
              className='quiz_course_manager_page' 
              onClick={() => navigate('/instructor/course_manager')}>
                Course Manager
              </button>
            </Col>
        </Row>
        {/* <Row style={{ padding: "20px" }} > */}
      {/* <button onClick={updateData}>Update</button> */}
      {/* Content Area */}
      <Col span={16} style={{ margin: "20px" }}>
        {activeContent?.type === "lesson" && (
          <Card title={activeContent.content.title}>
            {/* <iframe
              src={getEmbedUrl('https://www.youtube.com/watch?v=tWoo8i_VkvI' activeContent?.content?.videoUrl)}
              id="myIframe"
              frameborder="0"
              allowfullscreen
              style={{ width: "100%", "min-height": "500px" }}
            ></iframe> */}

            <ReactPlayer
              ref={playerRef}
              playing={false}
              controls={true}
              onPlay={handlePlay}
              onPause={handlePause}
              onProgress={handleProgress}
              onDuration={handleDuration}
              onEnded={handleVideoEnded}
              url={activeContent?.content?.videoUrl}

              // config={{
              //   youtube: {
              //     playerVars: {
              //       start: currentLessonDuration,
              //     },
              //   },
              // }}
            />
          </Card>
        )}
        {activeContent?.type === "quiz" && (
          <ConductQuiz
            courseId={id}
            sectionId={activeSectionId}
            quizId={activeContent.content.id}
          />
        )}
        {activeContent?.type === "quizResults" && (
          <Card title="Quiz Results">
            <p>
              <b className="red-color">
                Obtained marks: {quizResults[0]?.totalObtainedMarks}
              </b>
            </p>
          </Card>
        )}

        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Summary" key="1">
            {activeContent && activeContent.type === "lesson" && (
              <Card title="Summary">
                <p>
                  {activeContent.content !== null &&
                    activeContent.content.summary !== null &&
                    activeContent.content.summary}
                </p>
              </Card>
            )}
            {activeContent && activeContent.type === "quiz" && (
              <Card title="Instructions">
                <p>{activeContent.content.instructions}</p>
              </Card>
            )}
          </Tabs.TabPane>

          <Tabs.TabPane tab="Live Class" key="2">
            <LiveClass courseId={id} />
          </Tabs.TabPane>
        </Tabs>
      </Col>

      {/* Sidebar Navigation */}
      <Col span={6}>
        <h3>Course Content</h3>
        <Collapse
          accordion
          activeKey={activeSectionId}
          onChange={(key) => setActiveSectionId(key)}
        >
          {courseInfo?.sections?.map((section) => (
            <Panel header={section.title} key={section.id}>
              {section.lessons?.map((lesson) => (
                <Card
                  key={lesson.id}
                  style={{
                    "background-color":
                      activeContent?.type == "lesson" &&
                      activeContent?.content?.id === lesson.id
                        ? "#1677ff"
                        : "white",
                    "margin-bottom": "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleLessonClick(section.id, lesson)}
                >
                  <Row align="middle">
                    <Col span={2}>
                      <BookFilled />
                    </Col>
                    <Col span={16}>
                      <h4>{lesson.title}</h4>
                      <span style={{ fontSize: "70%" }}>
                        {lesson.attachmentType == "pdf" && (
                          <>
                            <FilePdfOutlined style={{ marginRight: "5px" }} />
                            PDF
                          </>
                        )}
                        {lesson.attachmentType != "" &&
                          lesson.attachmentType != "pdf" && (
                            <>
                              <ReadOutlined style={{ marginRight: "5px" }} />
                              {lesson.attachmentType.toUpperCase()}
                            </>
                          )}
                      </span>
                    </Col>
                    <Col span={6}>
                      <span>{lesson.duration}</span>
                    </Col>
                  </Row>
                </Card>
              ))}
              {section.quizzes?.map((quiz) => (
                <Card
                  key={quiz.id}
                  style={{
                    "background-color":
                      activeContent?.type == "quiz" &&
                      activeContent?.content?.id === quiz.id
                        ? "#1677ff"
                        : "white",
                    "margin-bottom": "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleQuizClick(section.id, quiz)}
                >
                  <Row align="middle">
                    <Col span={2}>
                      <BulbFilled />
                    </Col>
                    <Col span={16}>
                      <h4>{quiz.title}</h4>
                      <span style={{ fontSize: "70%" }}>
                        <QuestionCircleFilled style={{ marginRight: "5px" }} />
                        Quiz
                      </span>
                    </Col>
                    <Col span={6}>
                      <span>
                        {(parseDuration(quiz.duration) / 60 / 60).toFixed(2)}{" "}
                        Hours
                      </span>
                    </Col>
                  </Row>
                </Card>
              ))}
            </Panel>
          ))}
        </Collapse>
      </Col>
    {/* </Row> */}
    </Row>
  );
};

export default InstructorQuizResult;